import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderTwoComponent } from './loader-two.component';
import { TranslationModule } from 'src/app/i18n/translation.module';

@NgModule({
  declarations: [
    LoaderTwoComponent
  ],
  imports: [
    CommonModule,
    TranslationModule
  ],
  exports: [LoaderTwoComponent]
})
export class LoaderTwoModule { }
